{
  "app": {
    "name": "ATNT Constructor",
    "loading": "Loading…"
  },
  "auth": {
    "title": "Sign in",
    "subtitle": "Reservoir monitoring platform",
    "login": "Login",
    "loginPlaceholder": "Enter your login",
    "password": "Password",
    "passwordPlaceholder": "Enter your password",
    "submit": "Sign in",
    "logout": "Sign out",
    "showPassword": "Show password",
    "hidePassword": "Hide password"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "back": "Back",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "search": "Search",
    "preview": "Preview",
    "close": "Close",
    "retry": "Retry",
    "home": "Home"
  },
  "errors": {
    "generic": "Something went wrong",
    "notFound": "Page not found",
    "notFoundHint": "The page does not exist or you have no access to it."
  }
}
